
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightUpdates = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 8.404C4 4.048 7.456.5 11.624.5c4.167 0 7.623 3.548 7.649 7.904 0 2.635-1.27 4.93-3.05 6.261v1.957c0 .548-.457.991-.99 1.043l-6.99.574h-.1c-.255 0-.534-.104-.712-.287-.204-.182-.382-.47-.382-.756v-2.557C5.016 13.204 4 11.065 4 8.404zm11.155 12.601-6.937.522h-.076c-.534 0-.966-.418-1.017-.965a1.04 1.04 0 0 1 .94-1.122l6.938-.522a1.002 1.002 0 0 1 1.093.966 1.04 1.04 0 0 1-.94 1.121zm-2.21 3.286-2.49.209h-.077c-.534 0-.966-.418-1.017-.965a1.04 1.04 0 0 1 .94-1.122l2.517-.209a1.01 1.01 0 0 1 1.067.965 1.04 1.04 0 0 1-.94 1.122z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.663 8.377c-.05.47-.432.835-.89.835h-.075a.9.9 0 0 1-.788-.991c.152-1.487-1.118-2.035-1.27-2.087a.949.949 0 0 1-.534-1.174c.152-.47.66-.73 1.118-.548.94.34 2.668 1.618 2.44 3.965z",
  fill: "#fff"
})));

      const __svgRaw = "<svg width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M4 8.404C4 4.048 7.456.5 11.624.5c4.167 0 7.623 3.548 7.649 7.904 0 2.635-1.27 4.93-3.05 6.261v1.957c0 .548-.457.991-.99 1.043l-6.99.574h-.1c-.255 0-.534-.104-.712-.287-.204-.182-.382-.47-.382-.756v-2.557C5.016 13.204 4 11.065 4 8.404zM15.155 21.005l-6.937.522h-.076c-.534 0-.966-.418-1.017-.965a1.04 1.04 0 0 1 .94-1.122l6.938-.522a1.002 1.002 0 0 1 1.093.966 1.04 1.04 0 0 1-.94 1.121zM12.945 24.291l-2.49.209h-.077c-.534 0-.966-.418-1.017-.965a1.04 1.04 0 0 1 .94-1.122l2.517-.209a1.01 1.01 0 0 1 1.067.965 1.04 1.04 0 0 1-.94 1.122z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M15.663 8.377c-.05.47-.432.835-.89.835h-.075a.9.9 0 0 1-.788-.991c.152-1.487-1.118-2.035-1.27-2.087a.949.949 0 0 1-.534-1.174c.152-.47.66-.73 1.118-.548.94.34 2.668 1.618 2.44 3.965z\" fill=\"#fff\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light-updates.d7f9898806313f17530824fc1fb45932.svg"),
        {
          React: SvgLightUpdates,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      